module.exports = __webpack_public_path__ + "img/Carbon1.33d6ce66.jpg";